/* STADTHOLZ Produktseite: Alpine.js component `szProduct`.
   Gallery (crossfade + lightbox), variant picker, quantity stepper,
   add-to-cart states, accordions, mobile sticky bar. Product data comes inline
   from Liquid ({{ product | json }}), no fetch needed.

   Erweiterung 2026-09-14 (Umbau nach Claude-Design, SPEZIFIKATION §2/§5):
   - Galerie je Variante gruppiert (config.gallery + config.variantGroups).
     Konvention: Das Variantenbild startet eine Gruppe, alle folgenden Bilder
     gehoeren dazu bis zum naechsten Variantenbild. Bilder vor dem ersten
     Variantenbild gelten fuer alle Varianten. TODO: Konvention mit Cowork /
     JTL-Connector abstimmen (OFFENE-AUFGABEN „Varianten-Galerie nach Meller-Muster").
   - Auswahl je Option (selectOption), Beschriftung kommt aus product.options.
   - Nicht lieferbare Varianten bleiben waehlbar: CTA gesperrt, Fehlerbox mit
     Ausweichvorschlag, nie stillschweigend umschalten.
   - Optionale Linien-Eigenschaft „Verglasung" (Brille, Kaufbereich Variante A).
   - Empfehlungen unten per Shopify Recommendations API (Vanilla-JS, siehe unten). */

(function () {
  function registerSzProduct(Alpine) {
    Alpine.data('szProduct', function (config) {
      return {
        product: config.product || { images: [], variants: [] },
        inventoryMap: config.inventoryMap || {},
        unitPrices: config.unitPrices || {},
        urgencyThreshold: typeof config.urgencyThreshold === 'number' ? config.urgencyThreshold : 5,
        selectedVariantId: config.defaultVariantId || null,
        quantity: 1,
        imageIndex: 0,
        imageFading: false,
        lightboxOpen: false,
        addState: 'idle',
        openSections: { beschreibung: true },
        stickyBarVisible: false,

        // Weg zur Kasse nach dem Hinzufuegen (03.11.2026). Vorher verschwand die
        // Bestaetigung nach 2 Sekunden und der Kunde hatte auf dem Handy keinen
        // sichtbaren Weg weiter: 6 mobile Warenkoerbe, 0 Kaeufe im Oktober.
        // Designwahl des Geschenkgutscheins (Owner 03.11.2026). Steht als Eigenschaft
        // "Design" in der Bestellung und damit auf der Gutscheinkarte.
        gutscheinDesign: config.gutscheinDesignStandard || '',
        gutscheinDesignPflicht: config.gutscheinDesignPflicht === true,

        // Betragswahl des Gutscheins (Owner 03.11.2026). Die Variante wird am Preis in Cent
        // gesucht, damit die Oberflaeche mit fuenf Betraegen genauso arbeitet wie spaeter mit
        // 10 bis 500 Euro in Fuenferschritten.
        wunschbetrag: '',
        wunschbetragFehler: '',

        imWarenkorb: false,
        warenkorbAnzahl: 0,
        warenkorbWert: 0,
        versandfreiAbCents: typeof config.versandfreiAbCents === 'number' ? config.versandfreiAbCents : 8000,

        // Erweiterung Claude-Design
        gallery: Array.isArray(config.gallery) ? config.gallery : null,
        variantGroups: config.variantGroups || {},
        activeGroup: 0,
        selectedOptions: [],
        verglasung: config.verglasungDefault || '',
        addError: '',

        // Gravur zubuchen (Holzuhren, Owner 06.10.2026). Serviceprodukt + Text wie im Fliegen-Konfigurator.
        gravur: {
          enabled: false,
          text: '',
          variantId: config.gravurVariantId || null,
          priceCents: typeof config.gravurPriceCents === 'number' ? config.gravurPriceCents : 990,
          platzierung: config.gravurPlatzierung || 'Gehäuseboden',
        },

        init: function () {
          var self = this;
          if (!this.selectedVariantId && this.product.variants.length > 0) {
            var first = this.product.variants.find(function (v) {
              return v.available;
            });
            this.selectedVariantId = (first || this.product.variants[0]).id;
          }
          var cv = this.currentVariant;
          this.selectedOptions = cv && cv.options ? cv.options.slice() : [];
          if (cv && this.variantGroups[cv.id]) this.activeGroup = this.variantGroups[cv.id];
          this.syncImageToVariant();

          this.$nextTick(function () {
            var anchor = self.$refs.atcButton;
            if (!anchor || !('IntersectionObserver' in window)) return;
            new IntersectionObserver(
              function (entries) {
                self.stickyBarVisible = !entries[0].isIntersecting;
              },
              { threshold: 0 }
            ).observe(anchor);
          });
        },

        /* ---------- Galerie ---------- */

        // Sichtbarer Bildsatz: Bilder der aktiven Variantengruppe, danach die
        // gemeinsamen Bilder. Nie Bilder einer anderen Variante.
        get galleryVisible() {
          var self = this;
          if (!this.gallery || this.gallery.length === 0) {
            return (this.product.images || []).map(function (src) {
              return { src: src, thumb: src, zoom: src, alt: self.product.title || '', ki: false, gruppe: 0 };
            });
          }
          var hasGroups = this.gallery.some(function (g) {
            return g.gruppe;
          });
          // Produktvideos (gruppenlos) stehen direkt hinter dem ersten Bild,
          // damit sie auffallen (02.10.2026); uebrige gemeinsame Medien bleiben hinten.
          var isVideo = function (g) { return !!g.video; };
          var notVideo = function (g) { return !g.video; };
          if (!hasGroups) {
            var videosAll = this.gallery.filter(isVideo);
            var restAll = this.gallery.filter(notVideo);
            if (!videosAll.length || !restAll.length) return this.gallery;
            return [restAll[0]].concat(videosAll, restAll.slice(1));
          }
          var gid = this.activeGroup;
          var own = gid
            ? this.gallery.filter(function (g) {
                return g.gruppe === gid;
              })
            : [];
          var shared = this.gallery.filter(function (g) {
            return !g.gruppe;
          });
          var videos = shared.filter(isVideo);
          var sharedRest = shared.filter(notVideo);
          if (!videos.length) return own.concat(sharedRest);
          if (!own.length) return videos.concat(sharedRest);
          return [own[0]].concat(videos, own.slice(1), sharedRest);
        },

        get images() {
          return this.galleryVisible.map(function (g) {
            return g.src;
          });
        },

        get currentImage() {
          var list = this.galleryVisible;
          return list[this.imageIndex] || list[0] || null;
        },

        /* ---------- Variante ---------- */

        get currentVariant() {
          var id = this.selectedVariantId;
          return this.product.variants.find(function (v) {
            return v.id === id;
          });
        },

        get hasMultipleVariants() {
          return this.product.variants.length > 1;
        },

        get variantLabel() {
          var v = this.currentVariant;
          if (v) return v.title;
          return this.selectedOptions.join(' / ');
        },

        // Fuer Lieferumfang-Zeilen: ", Eiche" bzw. leer bei Einzelvariante
        get variantSuffix() {
          return this.hasMultipleVariants && this.variantLabel ? ', ' + this.variantLabel : '';
        },

        get priceFormatted() {
          var v = this.currentVariant;
          var base = v ? v.price : (typeof this.product.price === 'number' ? this.product.price : null);
          if (base === null) return '';
          // Gravur-Aufpreis je Stück, damit der angezeigte Preis dem Warenkorb entspricht
          var extra = this.gravur.enabled && this.gravurVerfuegbar ? this.gravur.priceCents : 0;
          return this.formatMoney(base + extra);
        },

        get gravurPreisHinweis() {
          if (!this.gravur.enabled || !this.gravurVerfuegbar) return '';
          return 'inkl. Gravur ' + this.formatMoney(this.gravur.priceCents);
        },

        get compareAtFormatted() {
          var v = this.currentVariant;
          if (!v || !v.compare_at_price || v.compare_at_price <= v.price) return '';
          return this.formatMoney(v.compare_at_price);
        },

        formatMoney: function (cents) {
          return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        },

        // Grundpreis (PAngV), fertig formatiert aus Liquid je Variante; leer = keine Angabe.
        get unitPriceText() {
          var v = this.currentVariant;
          if (!v) return '';
          return this.unitPrices[v.id] || '';
        },

        get canCheckout() {
          return !!(this.currentVariant && this.currentVariant.available) && this.gravurValid;
        },

        get gravurVerfuegbar() {
          return !!this.gravur.variantId;
        },

        get gravurValid() {
          if (!this.gravur.enabled || !this.gravurVerfuegbar) return true;
          return this.gravur.text.trim().length > 0;
        },

        get gravurTotalCents() {
          if (!this.gravur.enabled || !this.gravurVerfuegbar) return 0;
          return this.gravur.priceCents * this.quantity;
        },

        toggleGravur: function () {
          this.gravur.enabled = !this.gravur.enabled;
          this.addState = 'idle';
          this.addError = '';
        },

        get isUnavailable() {
          return !this.canCheckout;
        },

        get unavailableText() {
          if (!this.currentVariant) {
            return 'Diese Kombination gibt es gerade nicht. Deine übrige Auswahl bleibt erhalten.';
          }
          if (!this.hasMultipleVariants) return 'Dieser Artikel ist gerade nicht lieferbar.';
          return this.variantLabel + ' ist gerade nicht lieferbar. Deine übrige Auswahl bleibt erhalten.';
        },

        // Lieferbare Variante mit den meisten Uebereinstimmungen zur aktuellen Auswahl
        get alternativeVariant() {
          if (this.canCheckout) return null;
          var sel = this.selectedOptions;
          var cur = this.currentVariant;
          var best = null;
          var bestScore = -1;
          this.product.variants.forEach(function (v) {
            if (!v.available || (cur && v.id === cur.id)) return;
            var score = 0;
            (v.options || []).forEach(function (o, i) {
              if (o === sel[i]) score += 1;
            });
            if (score > bestScore) {
              best = v;
              bestScore = score;
            }
          });
          return best;
        },

        get alternativeLabel() {
          var alt = this.alternativeVariant;
          return alt ? 'Stattdessen ' + alt.title + ' ansehen' : '';
        },

        selectAlternative: function () {
          var alt = this.alternativeVariant;
          if (alt) this.selectVariant(alt);
        },

        // Abstand zur Versandkostengrenze, sichtbar sobald etwas im Warenkorb liegt.
        // Die Grenze kommt aus dem Section-Setting, damit es nur eine Wahrheit gibt.
        get versandHinweis() {
          var grenze = this.versandfreiAbCents;
          if (!grenze || !this.warenkorbWert) return '';
          if (this.warenkorbWert >= grenze) return 'Der Versand ist kostenlos.';
          var fehlt = (grenze - this.warenkorbWert) / 100;
          return (
            'Noch ' +
            fehlt.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) +
            ' bis zum kostenlosen Versand.'
          );
        },

        get ctaLabel() {
          if (this.addState === 'loading') return 'Wird hinzugefügt …';
          if (this.addState === 'success') return '✓ Im Warenkorb';
          if (!this.canCheckout) return 'Nicht lieferbar';
          if (this.addState === 'error') return 'Erneut versuchen';
          return 'In den Warenkorb';
        },

        // Inventory-driven urgency: shown only when stock is known, positive,
        // and at or below the threshold. Fed by the JTL sync via Shopify inventory.
        get urgencyText() {
          var v = this.currentVariant;
          if (!v || !v.available) return '';
          var qty = this.inventoryMap[v.id];
          if (typeof qty !== 'number' || qty <= 0 || qty > this.urgencyThreshold) return '';
          return qty === 1 ? 'Nur noch 1 Stück verfügbar' : 'Nur noch ' + qty + ' Stück verfügbar';
        },

        // Design-Regel: nicht lieferbare Varianten bleiben waehlbar.
        selectVariant: function (variant) {
          if (!variant) return;
          this.selectedVariantId = variant.id;
          this.selectedOptions = (variant.options || []).slice();
          this.addState = 'idle';
          this.addError = '';
          this.syncImageToVariant();
        },

        selectOption: function (position, value) {
          var opts = this.selectedOptions.slice();
          opts[position] = value;
          this.selectedOptions = opts;
          var match = this.product.variants.find(function (v) {
            return (v.options || []).every(function (o, i) {
              return o === opts[i];
            });
          });
          this.selectedVariantId = match ? match.id : null;
          this.addState = 'idle';
          this.addError = '';
          this.syncImageToVariant();
        },

        isOptionSelected: function (position, value) {
          return this.selectedOptions[position] === value;
        },

        // Gibt es eine lieferbare Variante mit diesem Wert zur uebrigen Auswahl?
        isOptionAvailable: function (position, value) {
          var sel = this.selectedOptions;
          return this.product.variants.some(function (v) {
            var o = v.options || [];
            if (!v.available || o[position] !== value) return false;
            return o.every(function (x, i) {
              return i === position || x === sel[i];
            });
          });
        },

        syncImageToVariant: function () {
          var v = this.currentVariant;
          if (this.gallery && this.gallery.length) {
            // Nicht existierende Kombination: Bildsatz bleibt stehen.
            if (v) {
              var gid = this.variantGroups[v.id] || 0;
              if (gid !== this.activeGroup) {
                this.activeGroup = gid;
                this.imageIndex = 0;
              }
            }
            if (this.imageIndex >= this.galleryVisible.length) this.imageIndex = 0;
            return;
          }
          if (!v || !v.featured_image) return;
          var src = v.featured_image.src || v.featured_image;
          var idx = this.images.findIndex(function (img) {
            return src.indexOf(img.split('?')[0].split('/').pop()) !== -1 || img === src;
          });
          if (idx >= 0) this.setImage(idx);
        },

        setImage: function (index) {
          if (index === this.imageIndex) return;
          var self = this;
          this.imageFading = true;
          setTimeout(function () {
            self.imageIndex = index;
            self.imageFading = false;
          }, 180);
        },

        nextImage: function () {
          var n = this.images.length;
          if (n > 1) this.setImage((this.imageIndex + 1) % n);
        },

        prevImage: function () {
          var n = this.images.length;
          if (n > 1) this.setImage((this.imageIndex - 1 + n) % n);
        },

        openLightbox: function () {
          if (this.images.length) this.lightboxOpen = true;
        },

        incrementQty: function () {
          this.quantity += 1;
        },

        decrementQty: function () {
          if (this.quantity > 1) this.quantity -= 1;
        },

        toggleSection: function (key) {
          this.openSections[key] = !this.openSections[key];
        },

        setVerglasung: function (label) {
          this.verglasung = label;
          this.addState = 'idle';
        },

        // Variante zu einem Betrag in Cent, oder null.
        variantePerCent: function (cent) {
          var vs = this.product.variants || [];
          for (var i = 0; i < vs.length; i++) {
            if (vs[i].price === cent && vs[i].available) return vs[i];
          }
          return null;
        },

        waehleBetrag: function (cent) {
          var v = this.variantePerCent(cent);
          if (!v) return;
          this.selectedVariantId = v.id;
          this.wunschbetrag = '';
          this.wunschbetragFehler = '';
          this.syncImageToVariant();
        },

        wunschbetragUebernehmen: function () {
          var roh = parseFloat(String(this.wunschbetrag).replace(',', '.'));
          if (!roh || isNaN(roh)) {
            this.wunschbetragFehler = '';
            return;
          }
          var euro = Math.round(roh / 5) * 5;
          if (euro < 10) euro = 10;
          if (euro > 500) euro = 500;
          this.wunschbetrag = euro;
          var v = this.variantePerCent(euro * 100);
          if (v) {
            this.selectedVariantId = v.id;
            this.wunschbetragFehler = '';
            this.syncImageToVariant();
          } else {
            // Kommt vor, solange nicht alle Stufen angelegt sind: dann bleibt die bisherige Wahl.
            this.wunschbetragFehler = euro + ' € gibt es nicht. Bitte wähl einen der Beträge oben.';
          }
        },

        addToCart: function () {
          if (!this.canCheckout || this.addState === 'loading') return;
          var self = this;
          // Beim Gutschein muss ein Design feststehen. Eines ist vorausgewaehlt, die Pruefung
          // faengt nur den Fall ab, dass die Auswahl aus irgendeinem Grund leer ist.
          if (this.gutscheinDesignPflicht && !this.gutscheinDesign) {
            this.addState = 'error';
            this.addError = 'Bitte waehl zuerst ein Design aus.';
            return;
          }
          var payload = { id: this.selectedVariantId, quantity: this.quantity };
          var props = {};
          if (this.gutscheinDesignPflicht && this.gutscheinDesign) props.Design = this.gutscheinDesign;
          if (this.verglasung) props.Verglasung = this.verglasung;
          if (this.gravur.enabled && this.gravurVerfuegbar) {
            // Eindeutige Klammer um Uhr und Gravur, wie im Fliegen-Konfigurator (sz-main-cart.liquid kennt _Gravurgruppe).
            var gruppe = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
            var text = this.gravur.text.trim();
            props['_Gravurgruppe'] = gruppe;
            props['Gravur'] = 'Ja (1 Seite)';
            props['Gravurtext'] = text;
            props['Gravur-Platzierung'] = this.gravur.platzierung;
            var titel = this.product.title + (this.currentVariant && this.currentVariant.title && this.currentVariant.title !== 'Default Title' ? ' – ' + this.currentVariant.title : '');
            payload = {
              items: [
                { id: this.selectedVariantId, quantity: this.quantity, properties: props },
                {
                  id: this.gravur.variantId,
                  quantity: this.quantity,
                  properties: {
                    '_Gravurgruppe': gruppe,
                    'Gravurtext': text,
                    'Platzierung': this.gravur.platzierung,
                    'Gehört zu': titel,
                  },
                },
              ],
            };
          } else if (Object.keys(props).length) {
            payload.properties = props;
          }
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          this.addState = 'loading';
          this.addError = '';
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          })
            .then(function (res) {
              return res
                .json()
                .catch(function () {
                  return {};
                })
                .then(function (data) {
                  if (!res.ok) {
                    var err = new Error('add failed');
                    err.description = data && (data.description || data.message);
                    throw err;
                  }
                  return data;
                });
            })
            .then(function (data) {
              self.addState = 'success';
              self.imWarenkorb = true;
              fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) {
                  return r.json();
                })
                .then(function (cart) {
                  self.warenkorbAnzahl = cart && cart.item_count ? cart.item_count : self.quantity;
                  self.warenkorbWert = cart && cart.total_price ? cart.total_price : 0;
                })
                .catch(function () {
                  self.warenkorbAnzahl = self.warenkorbAnzahl + self.quantity;
                });
              document.dispatchEvent(
                new CustomEvent('sz:cart:added', {
                  detail: { variantId: self.selectedVariantId, quantity: self.quantity, item: data },
                })
              );
              setTimeout(function () {
                self.addState = 'idle';
              }, 2000);
            })
            .catch(function (err) {
              self.addState = 'error';
              self.addError =
                err && err.description
                  ? String(err.description)
                  : 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
              setTimeout(function () {
                if (self.addState === 'error') self.addState = 'idle';
              }, 3000);
            });
        },
      };
    });
  }

  // Registrierung: vor Alpine.start (alpine:init). Falls Alpine schon geladen,
  // aber noch nicht gestartet ist, direkt registrieren.
  if (window.Alpine && typeof window.Alpine.data === 'function') {
    registerSzProduct(window.Alpine);
  } else {
    document.addEventListener('alpine:init', function () {
      registerSzProduct(window.Alpine);
    });
  }
})();

/* ---------- Empfehlungen (Shopify Recommendations API, ohne Alpine) ---------- */
(function () {
  function toCents(p) {
    if (typeof p === 'number') return p;
    if (typeof p !== 'string') return 0;
    if (/[.,]/.test(p)) return Math.round(parseFloat(p.replace(',', '.')) * 100);
    return parseInt(p, 10) || 0;
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function imgUrl(src, width) {
    var s = typeof src === 'string' ? src : src && src.src ? src.src : '';
    if (!s) return '';
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  function buildCard(p) {
    var a = el('a', 'sz-pdp-card' + (p.available === false ? ' is-unavailable' : ''));
    a.href = p.url;

    var media = el('div', 'sz-pdp-card__media');
    var src = p.featured_image || (p.images && p.images[0]);
    if (src) {
      var img = document.createElement('img');
      img.src = imgUrl(src, 600);
      img.alt = p.title || '';
      img.loading = 'lazy';
      img.width = 600;
      img.height = 600;
      media.appendChild(img);
    } else {
      media.appendChild(el('span', 'sz-pdp__ph-stripes'));
      media.appendChild(el('span', 'sz-pdp__ph-rule', 'Freisteller 1:1'));
    }
    a.appendChild(media);

    var body = el('div', 'sz-pdp-card__body');
    if (p.type) body.appendChild(el('span', 'sz-pdp-card__welt', p.type));
    body.appendChild(el('span', 'sz-pdp-card__name', p.title || ''));
    body.appendChild(el('span', 'sz-pdp-card__price', (p.price_varies ? 'ab ' : '') + money(toCents(p.price))));
    a.appendChild(body);
    return a;
  }

  function load(root) {
    var url = root.getAttribute('data-url');
    var grid = root.querySelector('[data-sz-empfehlungen-grid]');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
    if (!url || !grid || !window.fetch) return;
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        var list = ((data && data.products) || [])
          .filter(function (p) {
            return p && p.url && p.available !== false;
          })
          .slice(0, limit);
        if (!list.length) return;
        list.forEach(function (p) {
          grid.appendChild(buildCard(p));
        });
        root.hidden = false;
      })
      .catch(function () {});
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sz-empfehlungen]'), load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
